import React from 'react';
import { TfiPackage } from "react-icons/tfi";
import './Services.css';

const services = [
  {
    title: 'WAREHOUSING',
    description: 'Offer storage facilities for goods, including inventory management, picking, packing, and storage solutions tailored to client needs.',
    active: true
  },
  {
    title: 'FMCG LOGISTICS & DISTRIBUTION',
    description: 'We provide dedicated logistics and warehousing solutions for Fast Moving Consumer Goods (FMCG).'
  },
  {
    title: 'LAST-MILE DELIVERY',
    description: 'Deliver goods from distribution centers or warehouses to final destinations like homes or businesses with efficiency and speed.'
  },
  {
    title: 'EXPEDITED SHIPPING',
    description: 'Offer expedited or time-sensitive delivery options for urgent shipments.'
  },
  {
    title: 'TEMPERATURE-CONTROLLED TRANSPORTATION',
    description: 'Provide refrigerated or temperature-controlled transport for perishable or sensitive materials.'
  },
  {
    title: 'INVENTORY TRACKING',
    description: 'Implement systems like barcode scanning and RFID to monitor inventory levels and manage stock effectively.'
  },
  {
    title: 'Workforce Consulting',
    description: 'Providing expert workforce strategies to optimize talent acquisition, development, and organizational efficiency for growth.'
  },{
    title: 'Quick Commerce',
    description: 'Enabling ultra-fast delivery services with optimized logistics, ensuring swift and reliable customer order fulfillment.'
  }
];

const ServicesSection = () => {
  return (
    <section className="services-section">
      <p className="label">OUR SERVICES</p>
      <h2 className="heading">
        EFFICIENT AND RELIABLE SHIPPING<br />WITH VEDANT ENTERPRISES
      </h2>

      <div className="cards-grid">
        {services.map((service, index) => (
          <div
            className={`service-card ${service.active ? 'active' : ''}`}
            key={index}
          >
            <div className="icon-wrapper">
              <TfiPackage />
            </div>
            <h3>{service.title}</h3>
            <p>{service.description}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default ServicesSection;
